
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { RetrieveConfigFileSubscriptionsResponse } from '../entities/subscriptions-catalog-v1/models';
import { axiosInstance } from "../axios-instance";

class SubscriptionsCatalog {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getSubscriptions(): Promise<AxiosResponse<RetrieveConfigFileSubscriptionsResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<RetrieveConfigFileSubscriptionsResponse>(`${this.baseUrl}/subscriptions`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default SubscriptionsCatalog;
